(function () {
  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format =
        (window.MinimogSettings && window.MinimogSettings.money_format) ||
        (window.theme && window.theme.moneyFormat) ||
        '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  function initGallery(root) {
    if (root.dataset.fsGalleryReady === 'true') return;
    root.dataset.fsGalleryReady = 'true';

    var main = root.querySelector('[data-fs-main-image]');
    var thumbs = root.querySelectorAll('[data-fs-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
        });
        thumb.setAttribute('aria-selected', 'true');
        var src = thumb.getAttribute('data-image');
        if (src) main.src = src;
      });
    });
  }

  function initBuybox(root) {
    if (root.dataset.fsBuyboxReady === 'true') return;
    root.dataset.fsBuyboxReady = 'true';

    var choices = root.querySelectorAll('[data-fs-choice]');
    var planInput = root.querySelector('[data-fs-selling-plan]');
    var addBtn = root.querySelector('[data-fs-add]');
    var buyNowBtn = root.querySelector('[data-fs-buynow]');
    var priceEl = root.querySelector('[data-fs-price]');
    if (!choices.length) return;

    var addPrefix = addBtn ? addBtn.getAttribute('data-prefix') || 'Add to Cart' : '';
    var buyPrefix = buyNowBtn ? buyNowBtn.getAttribute('data-prefix') || 'Buy with Shop' : '';

    function selectChoice(choice) {
      choices.forEach(function (c) {
        c.classList.remove('is-active');
      });
      choice.classList.add('is-active');

      var planId = choice.getAttribute('data-plan-id') || '';
      var price = parseInt(choice.getAttribute('data-price'), 10);

      if (planInput) {
        if (planId) {
          planInput.value = planId;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }

      if (!isNaN(price)) {
        if (addBtn) addBtn.innerHTML = addPrefix + ' &middot; ' + formatMoney(price);
        if (buyNowBtn) buyNowBtn.innerHTML = buyPrefix + ' &middot; ' + formatMoney(price);
        if (priceEl) priceEl.textContent = formatMoney(price);
      }
    }

    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        selectChoice(choice);
      });
    });

    var active = root.querySelector('[data-fs-choice].is-active') || choices[0];
    if (active) selectChoice(active);

    // Buy with Shop -> add to cart then go straight to checkout
    if (buyNowBtn) {
      var form = root.querySelector('form');
      buyNowBtn.addEventListener('click', function () {
        if (!form || buyNowBtn.disabled) return;
        buyNowBtn.disabled = true;
        var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/') + 'checkout';
          })
          .catch(function () {
            buyNowBtn.disabled = false;
          });
      });
    }
  }

  function initFaq(root) {
    if (root.dataset.fsFaqReady === 'true') return;
    root.dataset.fsFaqReady = 'true';

    var items = root.querySelectorAll('[data-fs-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('[data-fs-faq-q]');
      var answer = item.querySelector('[data-fs-faq-a]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('active');

        items.forEach(function (other) {
          other.classList.remove('active');
          var otherAnswer = other.querySelector('[data-fs-faq-a]');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
        });

        if (!isOpen && answer) {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    var openItem = root.querySelector('[data-fs-faq-item].active');
    if (openItem) {
      var openAnswer = openItem.querySelector('[data-fs-faq-a]');
      if (openAnswer) openAnswer.style.maxHeight = openAnswer.scrollHeight + 'px';
    }
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-fs-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-fs-buybox]').forEach(initBuybox);
    root.querySelectorAll('[data-fs-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
